import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import { descargarFicha } from "../../services/apis_funcionarios";

const styles = {
  boton: {
    padding: 0,
    margin: 0,
    lineHeight: 1,
    background: "none",
    border: "none",
  },
  icon: {
    cursor: "pointer",
  },
};

function BotonDescargarFicha({
  idS,
  size = 30,
  color = "accent",
  placement = "right",
}) {
  const handleDescargar = () => {
    descargarFicha(idS).catch((err) => {
      console.error("Error al descargar la ficha:", err);
    });
  };

  const colorMap = {
    accent: "var(--color-accent)",
    primary: "var(--color-primary)",
    muted: "var(--color-text-muted)",
  };

  return (
    <OverlayTrigger
      placement={placement}
      trigger={["hover"]}
      delay={{ show: 1000, hide: 0 }}
      overlay={<Tooltip className="tooltip-ficha">Descargar ficha</Tooltip>}
    >
      <Button variant="link" onClick={handleDescargar} style={styles.boton}>
        <FiDownload
          size={size}
          style={{ ...styles.icon, color: colorMap[color] }}
        />
      </Button>
    </OverlayTrigger>
  );
}

export default BotonDescargarFicha;
